module.exports = require("./ar-KW.js");